import { useStaticQuery, graphql } from "gatsby";
import {
  mergePrismicPreview,
  resolveImage,
  resolveByPrefix,
  resolveExtraGroups,
  keysToCamel,
} from "@dataResolvers";

const query = graphql`
  query ContactPageQuery {
    prismicContactPage {
      id
      data {
        hero {
          heading {
            raw
          }
          subheading
          description {
            html
          }
          cta_text
        }
        instructions {
          heading
          description {
            html
          }
        }
        form_cta {
          heading
          description
          cta_text
        }
        office_intro {
          heading {
            raw
          }
          subheading
        }
        office_info {
          address
          phone
          email
          parking_1
          parking_2
          mass_transit_1
          mass_transit_2
        }
        office_map {
          url
          dimensions {
            width
            height
          }
        }
        meta_title
        meta_description
        meta_image {
          url
          dimensions {
            width
            height
          }
        }
      }
    }
  }
`;

const dataResolver = response => {
  const { prismicContactPage } = response;
  const { prefixed, unPrefixed } = resolveByPrefix(prismicContactPage.data, [
    "office_",
    "meta_",
  ]);
  const { office, meta } = prefixed;

  const unGrouped = resolveExtraGroups(unPrefixed);

  return keysToCamel({
    ...unGrouped,
    instructions: unPrefixed.instructions,
    office: {
      ...resolveExtraGroups(office),
      map: resolveImage(office.map),
    },
    meta: {
      ...meta,
      image: resolveImage(meta.image),
    },
  });
};

const useData = () => {
  const response = useStaticQuery(query);
  const data = mergePrismicPreview(response);
  return dataResolver(data);
};

export default useData;
